import { Routes } from '@angular/router';
import { permissionGuard } from './guard/auth/permission-guard';

export const routes: Routes = [
  {
    path: 'sign-in',
    title: 'Inicio de sesión',
    loadComponent: () =>
      import('./components/sign-in/sign-in.component').then((m) => m.SignIn),
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    canActivate: [permissionGuard],
    loadComponent: () =>
      import('./components/dashboard/dashboard').then(
        (m) => m.DashboardComponent,
      ),
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        title: 'Inicio',
        loadComponent: () =>
          import('./components/home/home').then((m) => m.Home),
      },
      {
        path: 'verification',
        title: 'Verificación SMS',
        loadComponent: () =>
          import('./components/verification-sms/verification-sms').then(
            (m) => m.VerificationSms,
          ),
      },
      {
        path: 'request',
        title: 'Terminar solicitud',
        loadComponent: () =>
          import('./components/request/request').then((m) => m.Request),
      },
      {
        path: 'payment',
        title: 'Aceptar / Registrar pago',
        loadComponent: () =>
          import('./components/complete-request/complete-request').then(
            (m) => m.CompleteRequest,
          ),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '404',
  },
  {
    path: '404',
    loadComponent: () =>
      import('./components/not-found/not-found').then((m) => m.NotFound),
  },
];
